import { render } from "./Loader.vue?vue&type=template&id=752aebec"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=752aebec&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__